import { Provider } from '@angular/core';
import { RoutingGuardService } from './routing.service';
import { AssetTypeService } from './asset-type-service';
import { MockDataService } from './utils/mock-data.service';

export const serviceProviders: Provider[] = [
  RoutingGuardService,
  AssetTypeService,
  MockDataService,
];

export * from './routing.service';
